import { useEffect, useLayoutEffect, useState } from 'react';
import gsap from 'gsap';

import BurgerMenu from './BurgerMenu.tsx';
import logo from '/logo.svg';

import { useLocation, useNavigate } from 'react-router-dom';

// Contextes
import { useMenu } from '../utils/BurgerMenuContexte.tsx';
import { useInTheGame } from '../utils/InTheGameContexte.tsx';

function Nav() {
    const { isBurgerMenuOpened } = useMenu();
    const { isGameStarted } = useInTheGame();
    const [isLogoPreloaded, setIsLogoPreloaded] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const handleAnimation = () => {
        const navLogo = document.querySelector('.nav__logo');
        const navAnimation = gsap.timeline();
        const logoAnimation = gsap.timeline();

        if (navLogo) {
            // Animation de la nav
            navAnimation.to('.nav', {
                height: isBurgerMenuOpened ? '27%' : isGameStarted ? '12%' : '27%',
                duration: 0.3,
                ease: 'power1.in',
            });

            // Animation du logo
            logoAnimation.to(navLogo, {
                scale: isBurgerMenuOpened ? 0.65 : isGameStarted ? 0.5 : 1,
                yPercent: isBurgerMenuOpened ? 0 : isGameStarted ? 17 : 0,
                xPercent: isBurgerMenuOpened ? 0 : isGameStarted ? -35 : 0,
                duration: 0.5,
                ease: 'power1.inOut',
            });

            // Animation des éléments du menu
            const menuItems = document.querySelectorAll('.hamburger__menu__list a');
            const burgerMenu = document.querySelector('.hamburger__menu');

            // Définir l'état initial avec GSAP
            gsap.set(menuItems, { y: -50, opacity: 0 });
            gsap.set(burgerMenu, {
                yPercent: isBurgerMenuOpened ? 100 : 0,
                pointerEvents: isBurgerMenuOpened ? 'all' : 'none',
            });

            navAnimation.to(menuItems, {
                y: isBurgerMenuOpened ? 0 : -50,
                opacity: isBurgerMenuOpened ? 1 : 0,
                stagger: 0.1,
                ease: isBurgerMenuOpened ? 'power1.inOut' : "'power1.in",
                duration: 0.5,
                pointerEvents: isBurgerMenuOpened ? 'all' : 'none',
            });
        }
    };

    useLayoutEffect(() => {
        // Pour s'assurer que le DOM est prêt
        if (document.readyState === 'complete') {
            requestAnimationFrame(handleAnimation);
        } else {
            window.addEventListener('load', () => requestAnimationFrame(handleAnimation));
            setTimeout(() => {
                handleAnimation();
            }, 100);
        }
    }, [isBurgerMenuOpened, isGameStarted, location.pathname]); // Ajout des dépendances au useEffect

    useEffect(() => {
        const preloadLogo = new Image();
        preloadLogo.src = logo;
        preloadLogo.onload = () => {
            setIsLogoPreloaded(true);
        };

        const handleBoxShadow = () => {
            const nextDiv = document.querySelector('.container');
            const nav = document.querySelector('.nav');
            if (nextDiv && nav) {
                const backgroundColor = window
                    .getComputedStyle(nextDiv)
                    .getPropertyValue('background-color');

                if (backgroundColor === 'rgb(255, 255, 255)') {
                    nav.classList.add('withBoxShadow');
                } else {
                    nav.classList.remove('withBoxShadow');
                }
            }
        };

        handleBoxShadow();

        const handlePopstate = () => {
            handleBoxShadow();
        };

        window.addEventListener('popstate', handlePopstate);

        return () => {
            window.removeEventListener('popstate', handlePopstate);
        };
    }, [location.pathname]);

    const handleLogoClick = () => {
        navigate('/accueil');
    };

    return (
        <nav
            className='nav'
            style={{ height: '27%' }}
        >
            {isLogoPreloaded && (
                <img
                    src={logo}
                    alt='Logo Cartes sur table'
                    className='nav__logo'
                    onClick={handleLogoClick}
                />
            )}
            <BurgerMenu />
        </nav>
    );
}

export default Nav;
